import(/* webpackMode: "eager", webpackExports: ["UserAside"] */ "/app/app/[locale]/(layout)/(chats)/chats/_components/UserAside/UserAside.tsx");
